import type { ButtonHTMLAttributes } from 'react'
import type { NamedIconComponentType } from '../../icon'
import type { LoadingIndicatorSizeType } from '../../loading-indicator'

export enum ButtonVariants {
  primary = 'primary',
  secondary = 'secondary',
  neutral = 'neutral',
  floating = 'floating',
  critical = 'critical',
}

export enum ButtonSize {
  xsmall = 'xs',
  small = 's',
  medium = 'm',
  large = 'l',
}

export type ButtonSizeType = `${ButtonSize}`
export type ButtonVariantsType = `${ButtonVariants}`

export interface BaseButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  type?: 'button' | 'submit' | 'reset'
  className?: string
  size?: ButtonSizeType
  variant?: ButtonVariantsType
  children?: React.ReactNode
  disabled?: boolean
  block?: boolean
  loading?: boolean
  rtl?: boolean
  label?: string
  leadingIcon?: NamedIconComponentType
  trailingIcon?: NamedIconComponentType
  loadingIndicatorSize?: LoadingIndicatorSizeType
}
